<template>
  <div class="quickview-body-yScroll">
    <!-- <a  @click.prevent.stop="reset" class="column has-bg-light is-border-bottom">
      <i class="fal fa-undo"></i> Réinitialiser la selection
    </a> -->
    <div class="columns is-gapless">
      <div class="column">
        <div class="field">
          <div class="control is-border has-icons-right" id="filtername">
            <input ref="input"
                   type="text" class="input is-light" v-model="search"
                   placeholder="Rechercher un lot dans la liste"
                   :class="{'is-degrad-info has-text-white':search && search.length}">
            <span class="icon is-right is-size-3">
              <i class="fal fa-search"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-paddingless quickview-liste-items">
        <ul>
          <template v-for="(g, key, i) in groupedLots">
            <li class="quickview-liste-items-header" :key="`type-${key}-${i}`">
              <b class="has-text-grey is-size-6">
                <span v-if="key !== 'null'">{{lotTypeLabel(key)}}</span>
                <span v-else>Parking(s)</span>
                ({{groupedLots[key].length}})
              </b>
            </li>
            <li v-for="l in groupedLots[key]" :key="`lot-${l.pk}-${i}`"
                class="columns column is-paddingless is-border-bottom"
                :class="{'item-is-disabled': (l.status === 'draft' || l.status === 'private')}"
                @click="l.status !== 'available' || select(l)">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
                <span class="dot is-small" :class="statusColors(l.status)"></span>
              </div>
              <div
                class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-55 is-overflow-hidden is-nowrap hover-degrad">
                <div><b>{{l.ref}}</b></div>
                <div class="columns is-size-7 is-gapless">
                  <div v-if="l.sale_price" class="column is-4 is-margin-right-xsmall">
                    <span class="has-text-grey">Prix : </span><span>{{l.sale_price}} {{$currency}}</span>
                  </div>
                  <div v-if="l.surface" class="column is-4 is-margin-right-xsmall">
                    <span class="has-text-grey">Surface : </span><span>{{l.surface}} m2</span>
                  </div>
                  <div v-if="l.floor" class="column is-3 is-margin-right-xsmall">
                    <span class="has-text-grey">Etage : </span><span>{{l.floor}}</span>
                  </div>
                </div>
              </div>
              <div
                class="column is-self-vcentered is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall w80p">
                <a v-if="entitiesPk.includes(l.pk)" class="button is-circle is-success">
                  <span class="icon is-small"><i class="fas fa-check"></i></span>
                </a>
                <a v-else-if="l.status === 'available'" class="button is-circle is-light">
                  <span class="icon is-small"><i class="fal fa-plus"></i></span>
                </a>
                <div v-else></div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
  import { groupBy } from 'lodash'
  import { DefaultValues, EntityMx } from '../../mixins'

  export default {
    name: 'LotSelection',
    mixins: [DefaultValues, EntityMx],
    data () {
      return {
        lots: [],
        search: null
      }
    },
    props: {
      source: {
        type: [Object, String]
      },
      params: Object
    },
    computed: {
      programPk () {
        if (this.source) {
          return this.source.pk || this.source
        }
      },
      canSubmit () {
        return this.entities.length > 0
      },
      filteredLots () {
        if (this.search && this.search.length) {
          const search = new RegExp(`(${this.search})`, 'igm')
          return this.lots.filter(x => x.ref.match(search))
        } else return this.lots
      },
      groupedLots () {
        let order = groupBy(this.filteredLots.sort((a, b) => {
          return b.lot_type - a.lot_type
        }), 'lot_type')
        let ordered = {}
        Object.keys(order).sort().forEach(function (key) {
          ordered[key] = order[key]
        })
        return ordered
      }
    },
    methods: {
      submit () {
        this.$emit('submit', this.entities)
      },
      getLots (page = 1) {
        this.loading = true
        this.$api.lotService.get({ program: this.programPk, page }).then(r => {
          this.loading = false
          this.lots = this.lots.concat(r.data.items)
          if (r.data.page < r.data.pages) {
            this.getLots(++r.data.page)
          } else {
            this.loading = false
            if (this.params.lots && this.params.lots.length) {
              this.entities = this.lots.filter(x => this.params.lots.map(x => x.lot || x.pk).includes(x.pk))
            }
          }
        }).catch(() => {
          this.loading = false
        })
      },
      select (r) {
        if (this.entitiesPk.includes(r.pk)) {
          this.unselectEntity(r)
        } else {
          this.selectEntity(r)
        }
      },
      statusColors (val) {
        const COLORS = {
          available: 'has-bg-disponible',
          optioned: 'has-bg-optionne',
          sold: 'has-bg-acte',
          draft: 'has-bg-draft',
          archived: 'has-bg-draft',
          reserved: 'has-bg-reserve'
        }
        return COLORS[val]
      }
    },
    created () {
      if (this.params.sourceLots) {
        this.lots = this.params.sourceLots
        if (this.params.lots && this.params.lots.length) {
          this.entities = this.lots.filter(x => this.params.lots.map(x => x.lot || x.pk).includes(x.pk))
        }
      } else {
        this.getLots()
      }
    },
    mounted: function () {
      this.$refs.input.focus()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/LotSelection.vue